import Modal from 'react-bootstrap/Modal';
import GooglePlacesDropdown from './GooglePlaces';
import { AddressDetails, DeliveryAddress } from './models/JobInterfaces';

interface JobQuoteDeliveryAddressProps {
    showModal: boolean;
    deliveryAddress: DeliveryAddress;
    invoiceDescription: string;
    trolleyRequired: boolean;
    showDeliveryAddress: boolean;
    showInvoiceDescription: boolean;
    showTrolley: boolean;
    readOnly: boolean;
    hideModal(): void;
    updateDeliveryAddress(updatedDeliveryAddress: DeliveryAddress): void;
    clearDeliveryAddress(): void;
    updateInvoiceDescription(updatedInvoiceDescription: string): void;
    updateTrolley(updatedTrolleyRequired: boolean): void;
    saveModal(): void;
}

const JobQuoteDeliveryAddressData = (props: JobQuoteDeliveryAddressProps) => {
   
    const setAddress = async (addressDetails: AddressDetails) => {
        var updAddress: DeliveryAddress = {
            deliveryAddress: addressDetails.fullAddress,
            deliveryAddressGooglePlaceId: addressDetails.placeId,
            deliveryAddressLatitude: addressDetails.latitude,
            deliveryAddressLongitude: addressDetails.longitude
        };
        props.updateDeliveryAddress(updAddress);
    }

    const handleInvDescChange = (e: any) => {
        props.updateInvoiceDescription(e.target.value);
    }

    const handleTrolleyChange = (e: any) => {
        props.updateTrolley(e.target.checked);
    }

    const save = (e: any) => {
        e.preventDefault();

        props.saveModal();
    }

    const googleContents = <GooglePlacesDropdown addressId="autocomplete" addressLabel={"Delivery Address"} placeholder={props.deliveryAddress.deliveryAddress} className="input-group" useLargeLabel={false} afterValid={setAddress} />

    return (
        <Modal size="lg" show={props.showModal} onHide={props.hideModal} backdrop="static">
            <Modal.Header className="modal__header--colour">
                <Modal.Title>{props.showDeliveryAddress ? "Delivery Address" : props.showInvoiceDescription ? "Invoice Description" : "Add Trolley"}</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className={props.showDeliveryAddress ? "" : "hidden" }>
                    <div>Set delivery address IF DIFFERENT from Site Address</div>
                    <div className="makeitflexspacebetween">
                        {googleContents}
                        <button className={props.readOnly ? "hidden" : "defaultbutton defaultbutton__small"} onClick={props.clearDeliveryAddress}>Clear</button>
                    </div>
                </div>
                
                <label className={props.showInvoiceDescription ? "input-group marginTop10" : "hidden"} htmlFor="invoiceDescription">
                    <div>Set invoice description IF DIFFERENT from Item Name, e.g. Event Extras - enter "Extra Toilet Paper"</div>
                    <span className="label">Invoice Description</span>
                    <input className="input marginRight10" type="text" maxLength={200} id="invoiceDescription" name="invoiceDescription" value={props.invoiceDescription} onChange={(e) => handleInvDescChange(e)} disabled={props.readOnly}></input>
                </label>
                <div className={props.showTrolley ? "marginTop10" : "hidden" }>
                    <div>If a trolley is required for this job, tick the box below.</div>
                    <label className="input-group" htmlFor="trolley">
                        <span className="label">Include Trolley?</span>
                        <input className="checkbox" type="checkbox" id="trolley" name="trolley" checked={props.trolleyRequired} onChange={(e) => handleTrolleyChange(e)} disabled={props.readOnly}></input>
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className={props.readOnly ? "hidden" : "popup-button--yes"} onClick={save}>Update</button>
                <button className={props.readOnly ? "popup-button--yes" : "hidden"} onClick={props.hideModal}>Close</button>
            </Modal.Footer>
        </Modal>
    )
}

export default JobQuoteDeliveryAddressData;